import useToggle from "v4/hooks/useToggle";
import useFetch from "v4/hooks/useFetch";
import useNotification from "v4/hooks/useNotification";
import {useHistory} from "react-router-dom";
import {useEffect} from "react";

export default function useHeaderCustomAction(customAction) {
    const {addNotification} = useNotification();
    const {replace} = useHistory();

    const [isOpen, toggleOpen] = useToggle();
    const [{data, isFinished}, fetchAction] = useFetch();

    const handleAction = () => {
        if (customAction.action.length > 0) {
            fetchAction({
                url: customAction.action,
                config: {
                    method: 'POST',
                }
            });
        }
        toggleOpen(false);
    }

    const handleReturn = (data) => {
        if (data?.messages) {
            data.messages.forEach((message) => {
                addNotification({type: message.type, message: message.message});
            });
        }
        if (data?.effects) {
            data.effects.forEach(({ redirectTo }) => {
                if (!redirectTo) return;

                const isPolUrl = redirectTo.startsWith('/') || redirectTo.includes(window.location.hostname);

                if (isPolUrl) {
                    replace(redirectTo)
                } else {
                    window.location.href = redirectTo;
                }
            });
        }
    }

    useEffect(() => {
        if (isFinished) {
            handleReturn(data)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, isFinished])

    return {
        isOpen,
        toggleOpen,
        handleAction,
    }
}
